import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import {
	L10N_CONFIG,
	L10N_LOCALE,
	L10nConfig,
	L10nLocale,
	L10nTranslatePipe,
	L10nTranslationService
} from 'angular-l10n';
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { ErrorHelper } from "../../shared/error.helper";
import { LoggerService } from "../../shared/logger.service";
import { Kernantwort } from "../../shared/response/kernantwort.model";
import { Antwort } from "../fragebogen/antwort.model";
import { Frage } from "../fragebogen/frage.model";
import { InsertEditMitDialogs } from "../immerdrin/bearbeitung/insertEdit.mitDialogs";
import { RestServiceImpl } from "../immerdrin/rest.service.impl";
import { RestService } from "../immerdrin/rest.service.interface";

const PATH_FILE = 'app/protected/verwaltungfragen/fragen.insertEdit.component.ts';

const BACKEND_PATH_PREFIX = 'frage/';

@Component({
    selector: 'oase-fragen-insertEdit.dialog',
    templateUrl: './fragen.insertEdit.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule  ]

})
export class FragenInsertEditComponent extends InsertEditMitDialogs {

	canSubmit: boolean = false;
	elternfragen: Frage[] = Array<Frage>(); //Mögliche abhängige Fragen
	elternantworten: Antwort[] = Array<Antwort>();
	fehlerMain: Kernantwort = null;

	constructor(
		public dialogRef: MatDialogRef<FragenInsertEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dataService: RestService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
		public authService: AuthService,
		public dialog: MatDialog,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public _logger: LoggerService) {

		super(dialogRef, data, dataService, authService, apiConfigService, http, dialog, _logger);
		this.getElternfragen();
	}

	setSubmit(newSubmit: boolean) {
		this._logger.log("setSubmit: ",this.aktuell.elternfrage);
		this._logger.log("setSubmit: ",this.aktuell.sortierung);
		this.canSubmit = (this.aktuell.fragestellung !=null && this.aktuell.fragestellung !== '') &&
			this.aktuell.typ != null && (this.aktuell.elternfrage.id != null || (this.aktuell.elternfrage.id == null && this.aktuell.sortierung != null)) && newSubmit;
	}

	// such comparison is needed for mat-select
	compareMitId(item1, item2) {
		return item1 && item2 ? item1.id === item2.id : item1 === item2;
	}

	curDate() {
		return new Date();
	}

	private getElternfragen() { //get Mögliche abhängige Fragen
		this._logger.log(PATH_FILE + ' - getElternfragen Begin');

		if(this.aktuell.id == undefined){
			this.aktuell.id = null;
		}

		this.http
			.get<Frage[]>(this.REST_API + '/getMoeglicheAbhaengigkeitsfragen/'+this.aktuell.id+'/'+this.aktuell.fragebogenId)
			.subscribe({
				next: (data) => {
					this.elternfragen = data;
					let obj = new Frage();
					obj.fragestellung=this.translation.translate(this.OBJ_LNG_NAME+'.keineAbhaengigkeit');
					obj.id = null;
					this.elternfragen.push(obj);
					if(this.aktuell.id != null){
						if(this.aktuell.elternfrage == null){
							this.aktuell.elternfrage = obj;
						}else{
							this.getElternantworten(this.aktuell.elternfrage);
						}
					}else{
						this.aktuell.elternfrage = obj;
					}
					this._logger.log(PATH_FILE + ' - getElternfragen End');
				},
				error: (err) => {
					ErrorHelper.handleError(err,"Fehler beim holen der Elternfragen",this._logger, this.translation)
				},
				complete: () => {
					this._logger.log(PATH_FILE + ' - Holen der Elternfragen abgeschlossen')
				}
			});
	} // getElternfragen

	getElternantworten(elternfrage: Frage){
		this._logger.log(PATH_FILE + ' - getElternantworten Begin');

		this.http
			.get<Antwort[]>(this.apiConfigService.REST_API_BASE() + '/antwort/liste/'+elternfrage.id)
			.subscribe({
				next: (data) => {
					this.elternantworten = data;
					if(this.aktuell.id != null && this.aktuell.elternfrage != null && this.aktuell.elternantworten.length > 0){
						for(const currentElternAntwort of this.aktuell.elternantworten){
							let index = this.elternantworten.findIndex(a => a.id == currentElternAntwort.id);
							if(index > -1){
								this.elternantworten[index].selected = true;
								this.elternantworten[index].sollGewaehlt = currentElternAntwort.sollGewaehlt;
							}
						}
					}
					this._logger.log(PATH_FILE + ' - getElternantworten End');
				},
				error: (err) => {
					ErrorHelper.handleError(err,"Fehler beim holen der Elternantworten",this._logger, this.translation)
				},
				complete: () => {
					this._logger.log(PATH_FILE + ' - Holen der Elternantworten abgeschlossen')
				}
			});
	}// getElternantworten

	checkElternantwort(elternantwort: Antwort){
		this._logger.log(PATH_FILE + ' - ELTERNANTWORTEN = ', this.elternantworten);
		let index = this.aktuell.elternantworten.findIndex(a => a.id == elternantwort.id);
		if(index == -1){
			if(elternantwort.selected){
				this.aktuell.elternantworten.push(elternantwort);
			}else{
				this._logger.log(PATH_FILE + ' - sollte wieder zurückgesetzt sein');
				elternantwort.sollGewaehlt = false;
			}
		}else if(!elternantwort.selected){
			this.aktuell.elternantworten.splice(index, 1);
			elternantwort.sollGewaehlt = false;
		}else{
			this.aktuell.elternantworten[index].sollGewaehlt = elternantwort.sollGewaehlt;
		}
		this._logger.log(PATH_FILE + ' - aktuelle Elternantwort = ', elternantwort);
		this._logger.log(PATH_FILE + ' - ELTERNANTWORTEN von aktueller Frage = ', this.aktuell.elternantworten);
	}// checkElternantworten


	setzeFehler(fehler: Kernantwort) {
		this.fehlerMain = fehler;
	}


}
